import { render, staticRenderFns } from "./importmessage.vue?vue&type=template&id=4b419af2&scoped=true&"
import script from "./importmessage.vue?vue&type=script&lang=js&"
export * from "./importmessage.vue?vue&type=script&lang=js&"
import style0 from "./importmessage.vue?vue&type=style&index=0&id=4b419af2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b419af2",
  null
  
)

export default component.exports